export const APPLICANT_CONTACT = 'applicant-contact';
export const PERSON_CONTACT = 'person-contact';
export const BILLING_ADDRESS = 'billing-address';
export const OTHER_DETAILS = 'other-details';
export const EXPRESS_LETTER_SERVICES = 'licence-details';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const EXPRESSLETTER = [
    {
        sectionID: EXPRESS_LETTER_SERVICES,
        sectionName: ' ',
        fieldList: [
            {
                id: 'types-express-letter',
                label: 'Type of Express Letter Services',
                type: 'text'
            },
            {
                id: 'public-contact-no',
                label: 'Public Contact No',
                type: 'text'
            },
            {
                id: 'use-of-system',
                label: 'Proposed Use of System',
                type: 'text',
                span: 12
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'text',
                span: 12
            }
        ]
    },

    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'text'
            }
        ]
    }
];
